import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'eventReplyDate'
})
export class EventReplyDatePipe implements PipeTransform {

    //実施期間内
    transform(list: any[]): any[] {
        var nowDateParseTime = new Date().getTime();

        return list.filter(item => item.reply_flg == "1");
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/event-reply-date.pipe.ts